import React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as Middleware from "@middlewares/index";
import moment from "moment-timezone";

interface PropsInterface {
  callback: any;
  data: any;
}

interface StateInterface {}

class Default extends React.Component<PropsInterface, StateInterface> {
  public render() {
    return (
      <>
        {console.log(this.props.data.status)}
        <div className="modal modal--calendar-event">
          <div className="modal__event">
            <button
              className="modal__close"
              onClick={() => {
                Middleware.Ui.Modal.close();
              }}
            />

            <div className="modal__event-row modal__event-row--first">
              <div className="modal__event-date">
                {moment(this.props.data.start).tz("Europe/Moscow").format("D MMMM")}
              </div>
              <div className="modal__event-time">
                {moment(this.props.data.start).tz("Europe/Moscow").format("HH:mm") +
                  " МСК (GMT +3)"}
              </div>

              {this.props.data.type === "webinar" ? (
                <div className="modal__event-type modal__event-type--broadcast">
                  Вебинар
                  <img src={require("@public/images/calendar-broadcast.svg")} alt="" />
                </div>
              ) : this.props.data.type === "broadcast" ? (
                <div className="modal__event-type modal__event-type--broadcast">
                  Трансляция
                  <img src={require("@public/images/calendar-broadcast.svg")} alt="" />
                </div>
              ) : this.props.data.type === "userEvent" ? (
                this.props.data.status ? (
                  <div className="modal__event-type modal__event-type--approved">
                    Подтверждено
                    <img src={require("@public/images/calendar-approved.svg")} alt="" />
                  </div>
                ) : this.props.data.isOwner ? (
                  <div className="modal__event-type modal__event-type--waiting">
                    Ждёт ответа
                    <img src={require("@public/images/calendar-waiting.svg")} alt="" />
                  </div>
                ) : (
                  <div className="modal__event-type modal__event-type--meet-request">
                    Запрос на встречу!
                    <img src={require("@public/images/calendar-request.svg")} alt="" />
                  </div>
                )
              ) : (
                <></>
              )}
            </div>
            <div className="modal__event-row">
              <div className="modal__event-name">
                {this.props.data.type === "userEvent" ? (
                  <Link to={`/event/${this.props.data.id}`}>{this.props.data.title}</Link>
                ) : (
                  <>{this.props.data.title}</>
                )}{" "}
              </div>
            </div>
            <div className="modal__event-row">
              {this.props.data.type === "webinar" ? (
                <a
                  target="_blank"
                  href={`//profi.travel/events/webinars/show/${this.props.data.id}`}
                  className="modal__event-btn btn btn--white-red"
                >
                  Перейти
                </a>
              ) : this.props.data.type === "broadcast" ? (
                <a
                  target="_blank"
                  href={`//profi.travel/broadcast/${this.props.data.id}`}
                  className="modal__event-btn btn btn--white-red"
                >
                  Перейти
                </a>
              ) : this.props.data.type === "userEvent" ? (
                this.props.data.status ? (
                  <Link
                    target="_blank"
                    to={`/event/${this.props.data.id}`}
                    className="modal__event-btn btn btn--red"
                  >
                    Зайти в видеокомнату
                  </Link>
                ) : (
                  <Link
                    target="_blank"
                    to={`/event/${this.props.data.id}`}
                    className="modal__event-btn btn btn--white-red"
                  >
                    Подробности встречи
                  </Link>
                )
              ) : (
                <></>
              )}

              {this.props.data.type === "userEvent" ? (
                <Link
                  to="#"
                  onClick={() => {
                    Middleware.Ui.Modal.open("EventCancel", {
                      callback: this.props.callback,
                      data: { id: this.props.data.id },
                    });
                  }}
                  className="modal__event-btn btn btn--transparent"
                >
                  Отменить событие
                </Link>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(
  connect(
    (Store: any) => {
      return { Store };
    },
    (Dispatch: any) => {
      return { Dispatch: (action: any) => Dispatch(action) };
    }
  )(Default)
);
